import { render, staticRenderFns } from "./ProjectSearchIndex.vue?vue&type=template&id=3171cbb3"
import script from "./ProjectSearchIndex.vue?vue&type=script&lang=js"
export * from "./ProjectSearchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports